import { render, staticRenderFns } from "./CompanyCommercialData.vue?vue&type=template&id=a1a61968"
import script from "./CompanyCommercialData.vue?vue&type=script&lang=js"
export * from "./CompanyCommercialData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports